import { graphql } from "relay-runtime"

export const NewsFragment = graphql`
  fragment NewsFragment on News {
    id
    criticalityLevel
    englishContent
    germanContent
    frenchContent
    italianContent
    startTime
    endTime
    displayFor
  }
`
